import { Routes } from '@angular/router';
import { EcorrGuard } from './common/components/ecorr-guard/ecorr.guard';
import { SurveysComponent } from './surveys/states/surveys/surveys.component';
import { SurveyReportNowComponent } from './surveys/components/survey-report-now/survey-report-now.component';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
    {
        path: 'portal',
        loadComponent: () => import('./auth/portal/portal.component').then(m => m.PortalComponent)
    },
    {
        path: 'specialcensus',
        loadComponent: () => import('./landing/special-census/special-census.component').then(m => m.SpecialCensusComponent)
    },
    {
        path: 'surveys',
        component: SurveysComponent,
        canActivate: [EcorrGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'submit-case',
        loadComponent: () => import('./support/states/submit-case/submit-case.component').then(m => m.SubmitCaseComponent)
    },
    {
        path: 'case-list',
        loadComponent: () => import('./support/states/case-list/case-list.component').then(m => m.CaseListComponent),
        canActivate: [EcorrGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'case-detail/:caseID',
        loadComponent: () => import('./support/states/case-detail/case-detail.component').then(m => m.CaseDetailComponent),
        canActivate: [EcorrGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'faq',
        loadComponent: () => import('./support/faq/faq.component').then(m => m.FaqComponent)
    },
    {
        path: '',
        redirectTo: 'portal',
        pathMatch: 'full'
    },
    {
        path: 'delegate/:delegationId',
        loadComponent: () => import('./surveys/delegate/delegate.component').then(m => m.DelegateComponent)
    },
    { 
        path: 'survey-report-now',
        component: SurveyReportNowComponent
    },
    {
        path: '404-not-found',
        component: NotFoundComponent
    },
    {
        path: '**',
        redirectTo: '404-not-found'
    }
];
